import { props, createAction } from '@ngrx/store';

export const trackedAdConsentClick = createAction(
  '[Ad Consent Click] Track Google Analytics',
  props<{ payload: { ngRouterUrl: string; relativeUrl: string; event: string; thirdpartyads: boolean } }>()
);
